import { Select, SelectItem, Input } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Products Sub Category page
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - categories: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { categories = [] } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama */}
            <Input
                label="Nama Sub Kategori"
                placeholder="Cari nama sub kategori..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        name: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Kategori - multiple selection */}
            <Select
                label="Kategori Induk"
                placeholder="Pilih kategori"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.category_id)
                            ? pending.category_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        category_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {categories.map((c) => (
                    <SelectItem key={String(c.value)} value={c.value}>
                        {c.title}
                    </SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
